import { parseMaskPoints } from './findingsMetrics.js';

export class FindingPositionGeometryError extends Error {
  constructor(code, message) {
    super(message);
    this.name = 'FindingPositionGeometryError';
    this.code = code;
  }
}

const isFiniteCoordinate = coordinate => coordinate !== null && coordinate !== '' && coordinate !== undefined
  && Number.isFinite(Number(coordinate));
const wrap = (coordinate, width) => ((coordinate % width) + width) % width;

function wrappedXCenter(points, width) {
  const xs = points.map(point => wrap(Number(point.x), width)).sort((a, b) => a - b);
  let gapIndex = xs.length - 1;
  let largestGap = width + xs[0] - xs[xs.length - 1];
  for (let index = 0; index < xs.length - 1; index += 1) {
    const gap = xs[index + 1] - xs[index];
    if (gap > largestGap) {
      largestGap = gap;
      gapIndex = index;
    }
  }
  const start = xs[(gapIndex + 1) % xs.length];
  const unwrapped = xs.map(x => (x < start ? x + width : x));
  return wrap((Math.min(...unwrapped) + Math.max(...unwrapped)) / 2, width);
}

export function deriveFindingBoxCenter(finding, image) {
  const width = Number(image?.width);
  const height = Number(image?.height);
  if (!(width > 0) || !(height > 0)) {
    throw new FindingPositionGeometryError('IMAGE_DIMENSIONS_INVALID', 'The panorama dimensions are unavailable.');
  }
  const points = parseMaskPoints(finding?.maskPoints);
  if (points.length >= 3) {
    const ys = points.map(point => Number(point.y));
    return {
      x: wrappedXCenter(points, width),
      y: Math.max(0, Math.min((Math.min(...ys) + Math.max(...ys)) / 2, height - 1)),
      source: 'mask-box',
    };
  }
  if (isFiniteCoordinate(finding?.imageXCenterCoordinate) && isFiniteCoordinate(finding?.imageYCenterCoordinate)) {
    return {
      x: wrap(Number(finding.imageXCenterCoordinate), width),
      y: Math.max(0, Math.min(Number(finding.imageYCenterCoordinate), height - 1)),
      source: 'stored-box',
    };
  }
  throw new FindingPositionGeometryError('FINDING_CENTER_UNAVAILABLE', 'The finding has no usable polygon or detection-box center.');
}
